'use es6';

import getIn from 'transmute/getIn';
import { STAGING_TEXT } from '../reducers/messageEditorStaging';
export const getStagingTextByThreadId = (threadId, stagingObj) => {
  return getIn([threadId, STAGING_TEXT], stagingObj);
};